import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import styles from "./compare-bar.module.css";
import { HeartFilledIcon, HeartOutlineIcon } from "@cinch-nx/design-system-icons";
import cx from "classnames";
import { useCompareBar } from "@cinch-labs/shared-compare-cars";
import { datadogRum } from "@datadog/browser-rum";
import { Actions as SearchActions, Context as SearchContext } from "@cinch-nx/data-search";
import { Context } from "../../datadog-data";
export var CompareIcon = function(param) {
    var isToggled = param.isToggled;
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        className: styles.compareCtaIcon,
        "aria-hidden": "true",
        children: isToggled ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M14 13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9a1 1 0 1 0 0-2H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 1 0-2 0v5Z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M4.262 7.452a.75.75 0 1 0-1.024 1.096l1.024-1.096ZM7.5 11.5l-.512.548a.75.75 0 0 0 1.059-.034L7.5 11.5Zm8.297-7.736a.75.75 0 0 0-1.094-1.028l1.094 1.028ZM3.238 8.548l3.75 3.5 1.024-1.096-3.75-3.5-1.024 1.096Zm4.809 3.466 7.75-8.25-1.094-1.028-7.75 8.25 1.094 1.027Z"
                })
            ]
        }) : /*#__PURE__*/ _jsx("path", {
            d: "M 14 13 a 1 1 0 0 1 -1 1 H 3 a 1 1 0 0 1 -1 -1 V 3 a 1 1 0 0 1 1 -1 h 10 V 0 H 3 a 3 3 0 0 0 -3 3 v 10 a 3 3 0 0 0 3 3 h 10 a 3 3 0 0 0 3 -3 V 3 a 3 3 0 0 0 -3 -3 V 2 A 1 1 0 0 1 14 3 z"
        })
    });
};
export var FavouriteIcon = function(param) {
    var isToggled = param.isToggled;
    return isToggled ? /*#__PURE__*/ _jsx(HeartFilledIcon, {
        size: 16
    }) : /*#__PURE__*/ _jsx(HeartOutlineIcon, {
        size: 16
    });
};
export var CompareBar = function(param) {
    var vehicle = param.vehicle;
    //TODO: Functionality replaced by compare/favourite provider in future
    var ref = useState(false), isFavouriteToggled = ref[0], setIsFavouriteToggled = ref[1];
    var ref1 = useCompareBar(), removeVehicle = ref1.removeVehicle, addVehicle = ref1.addVehicle, comparisonVehicles = ref1.comparisonVehicles, setShowModal = ref1.setShowModal, maxNumberOfItems = ref1.maxNumberOfItems;
    var vehicleId = vehicle.vehicleId, thumbnailUrl = vehicle.thumbnailUrl, make = vehicle.make, model = vehicle.model;
    var isSavedToCompare = comparisonVehicles.some(function(compareVehicle) {
        return vehicleId === compareVehicle.vehicleId;
    });
    var numberOfComparedVehicles = comparisonVehicles.length;
    var handleCompareOnClick = function() {
        var vehicleData = {
            vehicleId: vehicleId,
            vehicleTitle: "".concat(make, " ").concat(model),
            vehicleImage: thumbnailUrl,
            vehicleMake: make,
            vehicleModel: "".concat(model)
        };
        if (numberOfComparedVehicles >= maxNumberOfItems && !isSavedToCompare) {
            datadogRum.addAction(SearchActions.COMPARE_SHOWING_MODAL, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                maxNumberOfVehicles: maxNumberOfItems
            });
            return setShowModal(true);
        }
        if (isSavedToCompare) {
            datadogRum.addAction(SearchActions.COMPARE_VEHICLES_CTA_VEHICLE_REMOVED, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                vehicle: {
                    vehicleId: vehicleId,
                    make: make,
                    model: model
                }
            });
            removeVehicle(vehicleId);
        } else {
            datadogRum.addAction(SearchActions.COMPARE_VEHICLES_CTA_VEHICLE_ADDED, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                vehicle: {
                    vehicleId: vehicleId,
                    make: make,
                    model: model
                }
            });
            addVehicle(vehicleData);
        }
    };
    var handleFavouriteOnClick = function() {
        setIsFavouriteToggled(!isFavouriteToggled);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsxs("button", {
                    className: cx(styles.ctaButton, isSavedToCompare && styles.toggled),
                    onClick: function() {
                        return handleCompareOnClick();
                    },
                    children: [
                        /*#__PURE__*/ _jsx(CompareIcon, {
                            isToggled: isSavedToCompare
                        }),
                        " Compare"
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsxs("button", {
                    className: cx(styles.ctaButton, isFavouriteToggled && styles.toggled),
                    onClick: function() {
                        return handleFavouriteOnClick();
                    },
                    children: [
                        /*#__PURE__*/ _jsx(FavouriteIcon, {
                            isToggled: isFavouriteToggled
                        }),
                        " Favourite"
                    ]
                })
            })
        ]
    });
};
